import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

const SubNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  
  const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'fr', label: 'French' },
  ];

  const getPageTitle = (path) => {
    if (path === '/chat') return 'Aviation Assistant AI Chat';
    return '';
  };

  const isChat = location.pathname === '/chat';

  return (
    <>
      {/* Desktop Sub Navigation */}
      <nav className="hidden md:flex subnav-container">
        <div className="subnav-left">
          <button 
            onClick={() => navigate(-1)}
            className="subnav-back-btn"
          >
            <i className="fa-solid fa-arrow-left" />
          </button>
          <h5 className="subnav-title">
            {getPageTitle(location.pathname)}
          </h5>
        </div>

        {isChat && (
          <div className="subnav-right">
            <Select
              value={selectedLanguage}
              onValueChange={setSelectedLanguage}
              className="overflow-visible text-base"
            >
              <SelectContent className="select-content" >
                {languages.map((lang) => (
                  <SelectItem
                    key={lang.value}
                    value={lang.value}
                    className="select-item text-base"
                  >
                    {lang.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </nav>

      {/* Mobile Sub Navigation */}
      <nav className="md:hidden subnav-container-mobile w-full">
        <div className="subnav-left">
          <button 
            onClick={() => navigate(-1)}
            className="subnav-back-btn"
          >
            <i className="fa-solid fa-arrow-left" />
          </button>
          <p className="subnav-title align-middle h-4">
            {getPageTitle(location.pathname)}
          </p>
        </div>

        {isChat && (
          <div className="subnav-right">
            <Select
              value={selectedLanguage}
              onValueChange={setSelectedLanguage}
              className="overflow-visible text-base"
            >
              <SelectTrigger className="select-container">
                <SelectValue placeholder="Select language" />
              </SelectTrigger>
              <SelectContent className="select-content text-base">
                {languages.map((lang) => (
                  <SelectItem
                    key={lang.value}
                    value={lang.value}
                    className="select-item"
                  >
                    {lang.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </nav>
    </>
  );
};

export default SubNavigation; 